module.exports = "/_next/static/images/791a26345151ebf8a5ac65aacdb3855c-javier-ibarreche.png";